export const splitNumber = (num) => {
    const number = Number(num);
    if (isNaN(number)) return num; // Возвращаем исходное значение, если это не число

    return number.toLocaleString('ru-RU'); // Используем локаль 'ru-RU' для разделения пробелами
};
